import React from 'react'
import {Award, Heart, Shield, TrendingUp} from 'lucide-react'

export default function About() {
  return (
    <section id="agence" className="relative py-16 sm:py-20 md:py-24 overflow-hidden">
      {/* Image Background */}
      <img
        src="https://static.lumi.new/material/c0/c097b5f32f332525ad84b719d770d1eb.png"
        alt="Auto Star Background"
        className="absolute inset-0 w-full h-full object-cover"
      />
      
      {/* Dark Overlay for text readability */}
      <div className="absolute inset-0 bg-black/40"></div>
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="space-y-6 sm:space-y-8 animate-in fade-in slide-in-from-left duration-700">
            <div>
              <span className="text-blue-400 font-bold text-xs sm:text-sm uppercase tracking-widest mb-3 sm:mb-4 block">À propos</span>
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white mb-4 sm:mb-6 leading-tight" style={{ fontFamily: 'Syne, sans-serif' }}>
                AUTO STAR
                <br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-white to-red-500">Votre expert automobile</span>
              </h2>
            </div>
            
            <div className="space-y-4 sm:space-y-6 text-sm sm:text-base md:text-lg text-white/70 leading-relaxed" style={{ fontFamily: 'Outfit, sans-serif' }}>
              <p className="text-white/90 font-medium text-base sm:text-lg md:text-xl">
                Mandataire automobile basé à Plan de Campagne, la plus grande zone commerciale de France
              </p>
              <p>
                Située à seulement <span className="text-blue-400 font-semibold">10 km d'Aix-en-Provence</span> et <span className="text-red-400 font-semibold">20 km de Marseille</span>, notre agence vous accompagne dans tous vos projets automobiles.
              </p>
              <p>
                Que vous recherchiez un véhicule neuf, d'occasion, ou que vous souhaitiez importer un modèle spécifique, AUTO STAR met son expertise à votre service pour vous garantir les meilleures conditions du marché.
              </p>
              <p className="text-white font-semibold">
                Notre mission : simplifier votre achat automobile en vous offrant transparence, conseils personnalisés et tarifs avantageux.
              </p>
            </div>

            <a 
              href="#contact" 
              className="inline-flex items-center gap-3 bg-gradient-to-r from-blue-600 to-blue-500 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-bold text-sm sm:text-base md:text-lg hover:from-blue-500 hover:to-blue-400 transition-all shadow-lg hover:shadow-blue-500/50 hover:scale-105 group"
            >
              Nous contacter
              <Award className="group-hover:rotate-12 transition-transform flex-shrink-0" size={20} />
            </a>
          </div>

          <div className="grid grid-cols-2 gap-4 sm:gap-6 animate-in fade-in slide-in-from-right duration-700" style={{ animationDelay: '0.2s' }}>
            <div className="bg-gradient-to-br from-blue-600/20 to-blue-900/20 backdrop-blur-sm border border-blue-400/20 rounded-xl sm:rounded-2xl md:rounded-3xl p-5 sm:p-6 md:p-8 hover:scale-105 transition-all hover:border-blue-400/40 hover:shadow-xl hover:shadow-blue-500/20">
              <Award className="text-blue-400 mb-3 sm:mb-4" size={32} />
              <h3 className="text-white font-bold text-base sm:text-lg md:text-xl mb-2">Expertise</h3>
              <p className="text-white/60 text-xs sm:text-sm leading-relaxed">Service professionnel et conseils avisés</p>
            </div>
            <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm border border-white/20 rounded-xl sm:rounded-2xl md:rounded-3xl p-5 sm:p-6 md:p-8 hover:scale-105 transition-all hover:border-white/40 hover:shadow-xl hover:shadow-white/10 mt-6 sm:mt-8">
              <Heart className="text-white mb-3 sm:mb-4" size={32} />
              <h3 className="text-white font-bold text-base sm:text-lg md:text-xl mb-2">Satisfaction</h3>
              <p className="text-white/60 text-xs sm:text-sm leading-relaxed">100% de clients satisfaits</p>
            </div>
            <div className="bg-gradient-to-br from-red-600/20 to-red-900/20 backdrop-blur-sm border border-red-400/20 rounded-xl sm:rounded-2xl md:rounded-3xl p-5 sm:p-6 md:p-8 hover:scale-105 transition-all hover:border-red-400/40 hover:shadow-xl hover:shadow-red-500/20 -mt-6 sm:-mt-8">
              <Shield className="text-red-400 mb-3 sm:mb-4" size={32} />
              <h3 className="text-white font-bold text-base sm:text-lg md:text-xl mb-2">Confiance</h3>
              <p className="text-white/60 text-xs sm:text-sm leading-relaxed">Transparence totale garantie</p>
            </div>
            <div className="bg-gradient-to-br from-blue-400/20 to-blue-600/20 backdrop-blur-sm border border-blue-300/20 rounded-xl sm:rounded-2xl md:rounded-3xl p-5 sm:p-6 md:p-8 hover:scale-105 transition-all hover:border-blue-300/40 hover:shadow-xl hover:shadow-blue-400/20">
              <TrendingUp className="text-blue-300 mb-3 sm:mb-4" size={32} />
              <h3 className="text-white font-bold text-base sm:text-lg md:text-xl mb-2">Économies</h3>
              <p className="text-white/60 text-xs sm:text-sm leading-relaxed">Meilleurs prix du marché</p>
            </div>
          </div>
        </div>

        {/* GPS Location Image */}
        <div className="mt-8 sm:mt-12 md:mt-16 animate-in fade-in slide-in-from-bottom duration-700" style={{ animationDelay: '0.4s' }}>
          <a 
            href="https://maps.app.goo.gl/eifR6xzpoZTQ4PRB7" 
            target="_blank" 
            rel="noopener noreferrer"
            className="block bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl sm:rounded-2xl md:rounded-3xl p-3 sm:p-4 md:p-5 hover:bg-white/10 hover:border-blue-400/30 transition-all overflow-hidden cursor-pointer"
          >
            <img 
              src="https://static.lumi.new/material/31/31dd0342e3e882a0a72ce7a4f2cb117e.png" 
              alt="Localisation GPS AUTO STAR" 
              className="w-full h-auto rounded-lg sm:rounded-xl"
            />
          </a>
        </div>
      </div>
    </section>
  )
}
